import * as commonScripts from '../common'
import Glide from '@glidejs/glide'

const cmpViewpointCards = {
  component: null,
  viewport: 0,
  resizeTimer: 0,

  init: function (element) {
    const _ = this
    _.viewport = commonScripts.util.getViewportSize()
    _.component = element

    commonScripts.util.animationTranslate(this)
    commonScripts.util.inheritPermalink(element)

    _.updateBackground(element)

    window.addEventListener('resize', function (event) {
      clearTimeout(_.resizeTimer)
      _.resizeTimer = setTimeout(_.updateBackground(element), 500)
    })

    // If not in edit mode and the viewport size is mobile, then initialize the carousel
    if (!commonScripts.util.isEditMode() && _.viewport.width < 768) {
      const carouselDiv = _.component.querySelector('.glide')

      if (carouselDiv) {
        const track = carouselDiv.querySelector('.glide__track')
        const autoplay = _.component.getAttribute('data-autoplay')
        let loop = _.component.getAttribute('data-loop')
        loop = loop ? loop.toLowerCase() : loop
        const bullets = _.component.querySelectorAll('.glide__bullet')
        const options = {}
        options.type = (loop === 'true') ? 'carousel' : 'slider'
        options.autoplay = (isNaN(autoplay) || autoplay === '0') ? false : (autoplay * 1000)
        options.rewind = false
        let slideCount = carouselDiv.querySelectorAll('.glide__slide');
        if (slideCount.length > 1) {
            const glide = new Glide(carouselDiv, options)
            // Add listeners and rules for custom bullets.
            // Custom bullets needed when the markup is not within the .glide element.
            for (let i = 0; i < bullets.length; i++) {
                const bullet = bullets[i]
    
                if (i === 0) {
                _.updateBullets(bullets, i)
                }
    
                bullet.addEventListener('click', (event) => {
                glide.go('=' + i)
                })
            }
    
            glide.on('run', (event) => {
                _.updateBullets(bullets, glide._i)
            })
    
            glide.on('mount.after', (event) => {
                setTimeout(() => {
                _.updateTrack(track, glide)
                }, 500)
            })
    
            glide.on('run.after', (event) => {
                _.updateTrack(track, glide)
            })
    
            window.addEventListener('resize', (event) => {
                clearTimeout(_.resizeTimer)
                _.resizeTimer = setTimeout(() => {
                _.updateTrack(track, glide)
                }, 500)
            })
    
            glide.mount()

        } else{
            let bulletsDiv = carouselDiv.querySelector('.glide__bullets');
            if(bullets){
                bulletsDiv.style.display = 'none'
            }
        }  
      }
    }
  },

  updateBackground: function (element) {
    // Adjust the height of the background, if present.
    const bg = element.querySelector('.cmp-viewpoint-cards__bg')
    if (bg) {
      const card = element.querySelector('.cmp-viewpoint-cards__card')
      const media = card.querySelector('.cmp-viewpoint-cards__card__media')
      const offset = Math.ceil(media.offsetHeight * 0.66667)
      bg.style.height = 'calc(100% - ' + offset + 'px)'
    }
  },

  updateBullets: function (bullets, index) {
    for (let i = 0; i < bullets.length; i++) {
      bullets[i].classList.remove('glide__bullet--active')
    }
    bullets[index].classList.add('glide__bullet--active')
  },

  updateTrack: function (track, glide) {
    track.style.height = glide._c.Html.slides[glide._i].offsetHeight + 'px'
  }

}

export default cmpViewpointCards
